export default "__VITE_ASSET__BsBBMnZj__"